export default __webpack_public_path__ + "static/1497-055c503a3213bdd8676f38fd70437b99.gif";